<style lang="scss" scoped>
  .login-page{
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:url('../img/admin/login-bg.jpg') no-repeat center top #000;
  }
  .login-template{
    width:340px;
    margin:0 auto;
    text-align:center;
    .logo{
      padding:40px 0;
      img{
        max-width:50%;
      }
    }
    .contents{
      background:#fff;
      padding:40px;
      border-radius: 10px;
    }
    .default-btn{
      width:100%;
      display:block;
      padding:10px 0;
      text-align:center;
      background:#a9a9a9;
      color:#fff;
      font-size:12px;
      border-radius: 5px;
      &.active{
        background:#006a92;
      }
    }
  }
  .contents{
    .default-input{
      display: block;
      width:100%;
      padding: 0 10px;
      color: #000;
      font-size: 12px;
      border-radius: 5px;
      border:1px solid #ccc;
      height:37px;
      text-align:left;
    }
    .notice{
      font-size:12px;
      color:#ccc;
      text-align:left;
      padding:5px 0 10px 0;
    }
    .chk-area{
      display:flex;
      align-items: center;
      margin-bottom:20px;
    }
    .default-label{
      width:15px;
      height:15px;
    }
    .agree-label{
      margin: 0 0 0 10px;
      font-size:15px;
    }
    .view-inform-btn{
      text-decoration: underline;
      font-size:12px;
      margin-left:auto;
    }
  }
  .personal-information{
    position: fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    z-index:1000;
    .desc{
      position: absolute;
      width:600px;
      margin-left:-300px;
      height:500px;
      left:50%;
      top:50%;
      margin-top:-250px;
      z-index:1000
    }
    .pi-list{
      background:#fff;
      padding:20px;
      height:400px;
      overflow: hidden;
      overflow-y:auto;
    }
    .popup-close{
      position: absolute;
      top: -40px;
      right: 0;
      color: #fff;
      font-size: 40px;
      font-weight: bold;
      width: 40px;
      height: 40px;
      overflow: hidden;
    }
    &:after{
      display:block;
      position: absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      background:#000;
      opacity: 0.6;
      content:"";
    }
  }
  @media (min-width: 1300px) {
    .login-template{
      .logo{
        padding:200px 0 40px 0;
        img{
          max-width:100%;
        }
      }
      .contents{
        background:#fff;
        padding:40px;
        border-radius: 10px;
      }
      .default-btn{
        padding:11px 0;
        font-size:20px;
      }
    }
    .contents{
      .default-input{
        height:50px;
        font-size:20px;
      }
    }
  }
</style>
<template>
  <div class="login-page">
      <div class="login-template">
        <h1 class="logo">
          <img src="../img/admin/white-logo.png" alt="땡처리 부동산 닷컴">
        </h1>
        <div class="contents">
          <div class="chk-area">
            <input type="checkbox" id="agree-inform" class="default-chk" v-model="agreeInform"><label for="agree-inform" class="agree-label">개인정보 동의</label>
            <button type="button" class="view-inform-btn" @click="informView = true">내용보기</button>
          </div>
          <div class="phone-input-area">
            <button type="button" class="default-btn login-btn" :class="{active: agreeInform}" @click="phoneCertification()">핸드폰으로 인증하기</button>
          </div>
        </div>
      </div>
      <div class="personal-information" v-if="informView">
        <div class="desc">
          <button type="button" class="popup-close" @click="informView = false">
            <b-icon-x></b-icon-x>
          </button>
          <ul class="pi-list">
            <li>
              '어반에셋 매니지먼트' 에서는 (이하 '회사'는) 고객님의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다.
              회사는 개인정보취급방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
              회사는 개인정보취급방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.
            </li>
            <li>
              ο 본 방침은 : 2021 년 02 월 05 일 부터 시행됩니다.
            </li>
            <li>
              ■ 수집하는 개인정보 항목
            </li>
            <li>
              당사는 고객문의서비스 및 온라인입사지원 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.
            </li>
            <li>
              ο 수집항목 : 이름, 이메일, 쿠키 등
            </li>
            <li>
              ο 개인정보 수집방법 : 홈페이지(고객 문의)
            </li>
            <li>
              ■ 개인정보의 수집 및 이용목적
            </li>
            <li>
              회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
            </li>
            <li>
              서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 문의/답변
            </li>
            <li>
              ■ 개인정보 제공
            </li>
            <li>
              회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
            </li>
            <li>
              이용자들이 사전에 동의한 경우 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
            </li>
            <li>
              ■ 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항
            </li>
            <li>
              회사는 귀하의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)' 등을 운용합니다. 쿠키란 웹사이트를 운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다.
            </li>
          </ul>
        </div>
      </div>
      <form name="form1"  method="post">
      </form>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'Login',
  data () {
    return {
      phoneNumber: '',
      certification: false,
      certificationNumber: '',
      userId: '123',
      informView: false,
      agreeInform: false
    }
  },
  mounted () {
    window.onpopstate = event => {
      if (sessionStorage.getItem('token') !== null && this.$route.path === '/Login') {
        this.$router.push('/')
      }
    }
  },
  methods: {
    createMemInfo (params) {
      // console.log(params)
      this.$store.dispatch('apiMemInfo', params)
    },
    phoneCertification: function () {
      if (this.agreeInform) {
        const url = this.$store.state.common.urlpath
        let text = ''
        const send = this
        const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
        // 중복방지를 위한 난수 발생
        for (let i = 0; i < 5; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length))
        }

        window.open(url + '/api/chkbefore?orgurl=' + text, 'auth_popup', 'width=430,height=640,scrollbar=yes')

        const setInter = setInterval(function () {
          axios.post('/api/getLogin', {
            'key': text
          })
            .then(function (response) {
              if (response.data.rsltcd != null) {
                // console.log(response)
                if (response.data.rsltcd === 'B000') {
                  self.name = response.data.name
                  self.birth = response.data.birth
                  self.sexcd = response.data.sexcd
                  self.telno = response.data.telno
                  self.di = response.data.di
                  const params = {
                    'nmMembers': self.name,
                    'birMembers': self.birth,
                    'sexMembers': self.sexcd,
                    'numMembers': self.telno,
                    'diMembers': self.di,
                    'timestamp': Math.floor(+new Date() / 1000),
                    'flag': 'INSERT'
                  }
                  send.createMemInfo(params)
                }
                clearInterval(setInter) // 1초에 한번 호출 해
                alert(response.data.rsltmsg)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        }, 1000)
      } else {
        alert('개인정보 수집 및 이용 안내에 동의해 주세요.')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue